import styled, { css } from 'styled-components';
import NextImage from 'next/image';

import { Chevron } from '@solent-university/solent-icons';

export const Figure = styled.figure`
    margin: 0;
    padding: 0;
    overflow: hidden;
    position: relative;
    border-radius: 0.5rem;
`;

export const HeadingWrapper = styled.div`
    position: relative;
    display: flex;
    justify-content: center;
    z-index: -1;
`;

export const Heading = styled.h2`
    ${({ theme }) => css`
        position: relative;
        font-size: 1rem;
        font-weight: 200;
        line-height: 1.55;
        margin: 0;
        padding: 0.25rem 1rem;
        border-radius: 0.5rem 0.5rem 0 0;
        color: ${theme.colors.secondary.tints[1].hex};
        background: ${theme.colors.secondary.tints[12].hex};

        @media ${theme.breakpoints.large.media} {
            font-size: 1.5rem;
        }
    `}
`;

export const Border = styled.div<{
    $isHovering: boolean;
}>`
    ${({ theme, $isHovering }) => css`
        border: 0.25rem solid ${theme.colors.secondary.tints[12].hex};
        border-radius: 0.5rem;
        z-index: 3;
        overflow: hidden;
        transform: scaleY(1);
        transition: 0.2s ease-in-out;

        height: 18.75rem;
        position: relative;

        @media ${theme.breakpoints.large.media} {
            height: 28.25rem;
        }

        ${$isHovering &&
        css`
            border-color: ${theme.colors.secondary.hex};

            @media ${theme.breakpoints.large.media} {
                transform: scaleY(1.1);
                transform-origin: bottom;
            }
        `}
    `}
`;

export const ImageWrapperDefault = styled.div`
    ${({ theme }) => css`
        position: relative;
        z-index: 2;
        height: 18.75rem;

        @media ${theme.breakpoints.large.media} {
            height: 28.25rem;
        }
    `}
`;

export const StyledImage = styled(NextImage)<{
    $isHovering: boolean;
}>`
    ${({ theme, $isHovering }) => css`
        max-width: 100%;
        object-fit: cover;
        border-radius: 0.75rem;
        z-index: 2;
        height: 18.75rem;
        transform: scale(1);
        transition: 0.2s ease-in-out;

        @media ${theme.breakpoints.large.media} {
            height: 28.25rem;
        }

        ${$isHovering &&
        css`
            @media ${theme.breakpoints.large.media} {
                transform: scale(1.2);
            }
        `}
    `}
`;

export const PlayButton = styled.span<{ $isHovering: boolean }>`
    ${({ theme, $isHovering }) => css`
        position: absolute;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 50%;
        z-index: 2;
        cursor: pointer;
        transition-duration: 0.2s;
        background-color: ${theme.colors.accents[1].hex};
        border: 0.125rem solid ${theme.colors.secondary.hex};
        opacity: 50%;
        width: 5rem;
        height: 5rem;
        top: calc(50% - 2.5rem);
        left: calc(50% - 2.5rem);

        ${$isHovering &&
        css`
            transform: scale(1.6);
            opacity: 100%;
            border-width: 0.25rem;
        `}
    `}
`;

export const PlayIcon = styled(Chevron)`
    ${({ theme }) => css`
        color: ${theme.colors.secondary.hex};
        width: 1.25rem;
        height: 2.5rem;
        margin-left: 0.4rem;
    `}
`;
